// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"WhatInBox_TheComp__9hReh"};